import {useInfiniteQuery} from "react-query";
import {useMemo} from "react";

export interface PageData<T> {
    page: number;
    size: number;
    rows: T[];
    total: number;
}
export function useInfiniteListQuery<T>(
    key: string[] | unknown[],
    queryFn: (params: Record<string, number | string>) => Promise<PageData<T>>,
    {
        enabled = true,
        keepPreviousData = true,
    }: {
        enabled?: boolean;
        keepPreviousData?: boolean;
    } = {},
) {
    const queryResult = useInfiniteQuery<PageData<T>, any>({
        queryKey: [...key],
        queryFn: (context) => {
            return queryFn(Object.assign({}, {
            }, {
                ...context.pageParam as any
            }))
        },
        // initialPageParam: {} as any,
        enabled: enabled,
        getNextPageParam: (lastPage, allPages) => {
            const {
                page = 0,
                size = 20,
                total,
            } = lastPage;

            const hasNextPage=  ((page + 1) * size) < total;
            return hasNextPage ? {
                page: page + 1,
                size: size,
            } : false;
        },
        // suspense: true,
    });

    const {
        data,
        isFetching,
        hasNextPage,
        fetchNextPage,
    } = queryResult;

    const items = useMemo(() => {
        return queryResult.data?.pages.reduce((result: T[], page) => {
            if (page.rows) {
                return result.concat(page.rows);
            }
            return result;
        }, [])
    }, [queryResult?.data])
    // queryResult.data?.pages[0].pages
    const lastPage=  data ? data.pages[data.pages.length - 1] : undefined;
    return {
        ...queryResult,
        // searchParams,
        // setSearchParams,
        isLoading: isFetching,
        items,
        total: lastPage?.total,
        loadMoreStatus: !enabled ? 'before-ready'  : (isFetching ? 'loading' : (hasNextPage ? 'prepare' : "nomore")) as any,
        loadMoreFn: () => {
            if (isFetching) {
                return;
            }
            if (!hasNextPage) {
                return;
            }
            return fetchNextPage().then()

        }
    }
}